import React from "react";
import { Link } from "react-router-dom";
import { sectors, serviceGroups } from "../../data/siteData";

const deliverySteps = [
  {
    title: "Consult and size up the job",
    text: "We review the site need, intended finish, scale, access and design direction before fabrication begins.",
  },
  {
    title: "Fabricate with workshop control",
    text: "Production happens with close attention to dimensions, weld quality, durability and the visual rhythm of the design.",
  },
  {
    title: "Finish and install properly",
    text: "Installations are handled to land cleanly on site, with finishing decisions that support long-term use and appearance.",
  },
];

function Services() {
  return (
    <div className="page">
      <section className="page-hero">
        <p className="section-eyebrow">Services</p>
        <h1>Metal fabrication services that cover both everyday requirements and standout features.</h1>
        <p>
          Touchmark handles fabricated work for entrances, stair systems, fencing,
          decorative installations, structural supports and broader project needs.
        </p>
      </section>

      <section className="section">
        <div className="card-grid card-grid--services">
          {serviceGroups.map((service) => (
            <article key={service.title} className="info-card">
              <h2>{service.title}</h2>
              <p>{service.description}</p>
              <ul className="bullet-list">
                {service.bullets.map((bullet) => (
                  <li key={bullet}>{bullet}</li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </section>

      <section className="section section--contrast">
        <div className="section-heading">
          <p className="section-eyebrow">Where this work fits</p>
          <h2>Suitable for a wide range of residential and commercial project types.</h2>
        </div>
        <div className="tag-cloud">
          {sectors.map((sector) => (
            <span key={sector} className="tag">
              {sector}
            </span>
          ))}
        </div>
      </section>

      <section className="section split-section">
        <div>
          <p className="section-eyebrow">Delivery process</p>
          <h2>Every job still benefits from a clear, disciplined fabrication flow.</h2>
        </div>
        <div className="stacked-cards">
          {deliverySteps.map((step) => (
            <article key={step.title} className="info-card info-card--compact">
              <h3>{step.title}</h3>
              <p>{step.text}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="cta-band">
        <div>
          <p className="section-eyebrow">Need pricing or guidance?</p>
          <h2>We can help shape the right scope for the metal package before you commit.</h2>
        </div>
        <div className="hero__actions">
          <Link className="button button--solid" to="/contact">
            Talk about your project
          </Link>
          <Link className="button button--ghost" to="/projects">
            See project examples
          </Link>
        </div>
      </section>
    </div>
  );
}

export default Services;
